
/* injects from baggage-loader */

// Numerals
export const NumeralsI18n = {
  female: {    
    1: 'uma',
    2: 'duas',
    3: 'três',
    4: 'quatro',
    5: 'cinco',
    6: 'seis',
    7: 'sete',
    8: 'oito',
    9: 'nove'
  },
  male: {
    1: 'um',
    2: 'dois',
    3: 'três',
    4: 'quatro',
    5: 'cinco',
    6: 'seis',
    7: 'sete',
    8: 'oito',
    9: 'nove'
  }  
};


// Trophies

export const trophies = {
  default: {
    onca: require('_images/trophies/bagde-onca.png'),
    macaco: require('_images/trophies/bagde-macaco.png'),
    peixeboi: require('_images/trophies/bagde-peixeboi.png'),
    tamandua: require('_images/trophies/bagde-tamandua.png')
  },
  emblem: {
    onca: require('_images/trophies/new-emblem/emblem-onca.png'),
    macaco: require('_images/trophies/new-emblem/emblem-macaco.png'),
    peixeboi: require('_images/trophies/new-emblem/emblem-peixeboi.png'),
    tamandua: require('_images/trophies/new-emblem/emblem-tamandua.png'),
    completo: require('_images/trophies/new-emblem/emblem-full_plus.png')
  }, 
  bigger: {
    onca: require('_images/trophies/emblem-onca.png'),
    macaco: require('_images/trophies/emblem-macaco.png'),
    peixeboi: require('_images/trophies/emblem-peixeboi.png'),
    tamandua: require('_images/trophies/emblem-tamandua.png'),
    completo: require('_images/trophies/emblem-full_plus.png')
  }
}


// Animals
export const Animals = {
  peixeboi: 0,
  onca: 1,
  tamandua: 2,
  macaco: 3
}


// WEBPACK FOOTER //
// ./src/app/index.const.js